import React from 'react'
export default function ProhibitIcon() {
  return (
    <svg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8 14.5C11.3137 14.5 14 11.8137 14 8.5C14 5.18629 11.3137 2.5 8 2.5C4.68629 2.5 2 5.18629 2 8.5C2 11.8137 4.68629 14.5 8 14.5Z'
        stroke='#F0284C'
        strokeMiterlimit='10'
      />
      <path d='M3.75781 4.26025L12.2431 12.7455' stroke='#F0284C' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  )
}
